import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";
import { IKizDocBatchDisposalRequest, IKizDocBatchDisposalResult, IKizDocEditDto, IKizDTO, IKizViewDTO } from "../../coreapi-dto/dirs/kiz";


class KizDocRequest extends BaseDirRequest<IKizViewDTO, IKizDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "KizDoc", token, eventHandler)
    }

    create702Document(idInvoiceGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.post2<null>(`${this._baseUrl}/${this._routePrefix}/Create702Document/${idInvoiceGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    create702DocumentType3(idInvoiceGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.post2<null>(`${this._baseUrl}/${this._routePrefix}/Create702DocumentType3/${idInvoiceGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    create521ChequeDocument(idChequeGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.post2<null>(`${this._baseUrl}/${this._routePrefix}/Create521ChequeDocument/${idChequeGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    warningCreate702Document(idInvoiceGlobal: string, receiveType: number, callback?: (e: CoreApiResponse<number | null>) => void) {
        this.post2<number>(`${this._baseUrl}/${this._routePrefix}/Create702DocumentWarning/${idInvoiceGlobal}/${receiveType}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    createRepeatSendDocument(idDocumentGlobal: string, callback?: (e: CoreApiResponse<null>) => void) {
        this.post2<null>(`${this._baseUrl}/${this._routePrefix}/CreateRepeatSendDocument/${idDocumentGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    createRepeatSendPackingInfo(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean | null>) => void) {
        this.post2<boolean>(`${this._baseUrl}/${this._routePrefix}/CreateRepeatSendPackingInfo/${idDocumentGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    createRepeatSendInfoGismt(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean | null>) => void) {
        this.post2<boolean>(`${this._baseUrl}/${this._routePrefix}/CreateRepeatSendInfoGismt/${idDocumentGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    createRepeatSendRvDisposal(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean | null>) => void) {
        this.post2<boolean>(`${this._baseUrl}/${this._routePrefix}/CreateRepeatSendRvDisposal/${idDocumentGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    createRepeatSend531Disposal(idDocumentGlobal: string, callback?: (e: CoreApiResponse<boolean | null>) => void) {
        this.post2<boolean>(`${this._baseUrl}/${this._routePrefix}/CreateRepeatSend531Disposal/${idDocumentGlobal}`, null, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    createRepeatBatchDisposal(request: IKizDocBatchDisposalRequest, callback?: (e: CoreApiResponse<IKizDocBatchDisposalResult>) => void) {
        this.post<IKizDocBatchDisposalResult>(`${this._baseUrl}/${this._routePrefix}/createRepeatBatchDisposal`, request, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                }
            }
            callback?.(e);
        })
    }

    GetKizDocByIdDocumentAsync (idDocumentGlobal: string, callback?: (e: CoreApiResponse<IKizDocEditDto>) => void) {
            this.get<IKizDocEditDto>(`${this._baseUrl}/${this._routePrefix}/GetByIdDocument/${idDocumentGlobal}`, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
               if(this._eventHandler){
                   if(e.respType==="isFailed"){
                       this._eventHandler.onGetResponse(e);
                   }
                }
                callback?.(e);
            })
    }

    revise(request: IKizDocEditDto, callback?: (e: CoreApiResponse<boolean>) => void, failCallback?: () => void) {
        this.post<boolean>(`${this._baseUrl}/${this._routePrefix}/revise`, request, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                    failCallback?.()
                }
            }
            callback?.(e);
        })
    }

}

export default KizDocRequest